import * as React from "react";
import Result from "antd/es/result";
import Button from "antd/es/button";

export const SuccessDisplay: React.FunctionComponent = () => {
    return (
        <Result
            title="Transfer successful!"
            extra="Check your wallet for LLD"
            status="success"
            subTitle={<Button href="/">Make another trade</Button>}
        />
    );
};
